import { api } from '@/lib/api/client'

/** `GET /notifications/unread-count` counts the caller's unread notifications. */
export async function getUnreadNotificationCount(): Promise<number> {
  const { data } = await api.get<{ data: { count: number } }>('/notifications/unread-count')

  return data.data.count
}
